/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Period_Top_EmptyInputs */

const en_us2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No exercise with working sets in this period.`)
};

const pt_br2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com séries de trabalho neste período.`)
};

const es_419_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio con series de trabajo en este período.`)
};

const pt_pt2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com séries de trabalho neste período.`)
};

const fr_fr2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice avec des séries de travail sur cette période.`)
};

const de_de2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übung mit Arbeitssätzen in diesem Zeitraum.`)
};

const it_it2_wrapped_period_top_empty = /** @type {(inputs: Wrapped_Period_Top_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio con serie allenanti in questo periodo.`)
};

/**
* | output |
* | --- |
* | "No exercise with working sets in this period." |
*
* @param {Wrapped_Period_Top_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_top_empty = /** @type {((inputs?: Wrapped_Period_Top_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Top_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_top_empty(inputs)
	if (locale === "es-419") return es_419_wrapped_period_top_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_top_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_top_empty(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_top_empty(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_top_empty(inputs)
	return en_us2_wrapped_period_top_empty(inputs)
});
export { wrapped_period_top_empty as "wrapped-period.top_empty" }